<div class="info-user">
	<div class="info-user-data" *ngIf="seatStatus == 'user' else invitation">
		<core-avatar-img [user]="seatSetting.user" [size]="84"></core-avatar-img>
		<div >
			<span class="info-user-detail"><strong><em>{{seatSetting.user.name}} ({{seatSetting.user.email}})</em></strong></span>
			<span class="info-user-added" *ngIf="seatSetting.date_created" ><em>Added on</em>: {{seatSetting.date_created | date:'dd MMM yyyy'}}</span>
			<!-- if date_expired is null, user doesn't expired -->
			<span class="info-user-review" *ngIf="seatSetting.seat.status.date_expired" ><em>Renews on</em>: {{seatSetting.seat.status.date_expired | date:'dd MMM yyyy'}}</span>
		</div>
	</div>
	<ng-template #invitation>
		<div class="info-user-data">
			<core-avatar-img [user]="seatSetting.user" [size]="84" ></core-avatar-img>
			<div>
				<span class="info-user-detail"><strong><em>{{seatSetting.user.name}} ({{seatSetting.user.email}})</em><span class="pending"> - PENDING</span></strong></span>
				<span class="info-user-added" *ngIf="seatSetting.date_created" ><em>Added on</em>: {{seatSetting.date_created | date:'dd MMM yyyy'}}</span>
				<!-- NOT shown now. <span class="info-user-review" *ngIf="seatSetting.seat.status.date_expired" ><em>Expire on</em>: {{seatSetting.seat.status.date_expired | date:'dd MMM yyyy'}}</span> -->
				<span class="info-user-review" *ngIf="isExpired" ><em>EXPIRED</em></span>
			</div>
		</div>
	</ng-template>
	<div class="info-user-tool">
			<core-helpers-navigation-three-dots-menu
				[menu]="menu"
				(action)="onMenuSelect($event)"
			></core-helpers-navigation-three-dots-menu>
	</div>
</div>
